import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { emptyMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { AssetCaptionType } from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetCaptions';
import {
  fundLockedCaption,
  professionalInvestorCaption,
  qualifiedInvestorCaption,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetCaptions/constants';
import {
  applicationAmountFilter,
  closedToApplicationDescriptionFilter,
  getRiskRatingLevelFilter,
  isInvestorFilter,
  quotationRedemptionOrLiquidityTermFilter,
  redemptionDaysFilter,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetFilters/constants';
import {
  transformCustomCategories,
  transformCustomFilters,
} from '../../../../../../../BatchTicket/components/DynamicAsset/constants';

import { FundsProduct } from '.';

const fundsCaptions: AssetCaptionType[] = [
  qualifiedInvestorCaption,
  professionalInvestorCaption,
  fundLockedCaption,
];

export const fundsTableHead: TableHeadItemRecurse[] = [
  { title: '', flex: 0.5 },
  { title: 'Fundos', orderValue: 'productName', flex: 3 },
  { title: 'Gestora', orderValue: 'managerName', flex: 2 },
  { title: 'Tipo', orderValue: 'productCategory', flex: 2 },
  { title: 'Rent. 12 meses', orderValue: 'profitabilityTwelveMonthsNormalized', flex: 2 },
  { title: 'Taxa admin.', orderValue: 'administrationFee', flex: 2 },
  { title: 'Aplic. Inicial.', orderValue: 'participateMinimumAmount', flex: 2 },
  { title: 'Aplic. Min', orderValue: 'applicationMinimumAmount', flex: 2 },
];

export const availableProductFundsConstant = {
  id: 'funds',
  title: 'Fundos',
  color: 'product.fundos' as ColorTypes.Option,
  principalComponent: FundsProduct,
  marketStatusSelector: emptyMarketStatusQuery,
  tableHead: fundsTableHead,
  hideTableHead: false,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [
      getRiskRatingLevelFilter('funds'),
      ...transformCustomFilters(customFilters),
      isInvestorFilter,
      closedToApplicationDescriptionFilter,
      quotationRedemptionOrLiquidityTermFilter,
      applicationAmountFilter,
      redemptionDaysFilter,
    ];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  categoriesField: 'productCategory',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'productCategory'),
  captions: fundsCaptions,
  hasRefresher: false,
} as const;
